module.exports = __webpack_public_path__ + "img/mask-octogon.0781f95c.svg";